<!--
Author: TangChen
Date: 2019-02-28
Desc: 自选组合购买基金列表，由index.js 配置引入
-->
<template>
    <div :class="'bizcomp-optional-general bizcomp ' + className">
        <comp-title :title="title" />
        <fund-risk-filter :qryall="qryallfund" v-on:qry-change="qryChange" />
        <combo-table ref="comboTable" :flag="flag" v-on:combo-list="getData" />
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import comboTable from "@/components/fund/comboTable";
import fundRiskFilter from "@/components/form/fundRiskFilter";
export default {
    name: "OptionalGeneral",
    components: {
        comboTable,
        fundRiskFilter
    },
    mixins: [mixin],
    data () {
        return {
            selFund: [],
            url: "generalbuy",
            qryallfund: "",
            flag: "1" // 组合类型，定投
        };
    },
    mounted () {
        this.getSelFund();
    },
    methods: {
        getData (val) {
            let _this = this;
            val.proto = "plan";
            this.$util.fundRiskCheck(this, val, res => {
                if (res) {
                    const _x = Object.assign({}, res, { way: "59" });
                    sessionStorage.setItem(_this.url, JSON.stringify(_x));
                    _this.$router.push({ name: _this.url, query: { fundcode: res.fundcode } });
                }
            });
        },
        // 查询自选组合购买基金信息
        getSelFund (flag) {
            if (this.selFund.length > 0 && !flag) {
                this.$refs.comboTable.fundList = this.selFund;
                return;
            }
            let _this = this;
            const _x = {
                flag: this.flag,
                pagecount: "1000",
                pageoffset: "0",
                qryallfund: this.qryallfund
            };
            this.$util.request("trade/fund/list", _x).then(res => {
                if (res.data) {
                    _this.selFund = res.data[0];
                    _this.qryallfund = res.data[1][0].qryallfund;
                    const info = _this.$cache.getUser();
                    info.qryallfund = _this.qryallfund;
                    _this.$store.dispatch("setInfo", info);
                    _this.$refs.comboTable.fundList = res.data[0];
                }
            });
        },
        // 改变风险过滤规则
        qryChange (val) {
            this.qryallfund = val;
            this.getSelFund(true);
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.bizcomp-optional-general {
    .risk-filter-text {
        margin: 0;
        border: none;
        padding: 5px 10px;
    }
}
</style>
